/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

'use client';

import { useContext } from 'react';
import { TracesContext } from '@/context';

export const useTraces = () => useContext(TracesContext);
